import { render } from "./defultStyling.vue?vue&type=template&id=28fa6acc"
import script from "./defultStyling.vue?vue&type=script&lang=js"
export * from "./defultStyling.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__